import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from "keycloak-angular";
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { AlertController, IonModal } from '@ionic/angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, finalize, of, timeout } from 'rxjs';
import moment from 'moment';
import { Browser } from '@capacitor/browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bbank',
  templateUrl: './bbank.component.html',
  styleUrls: ['./bbank.component.scss'],
})
export class bBankComponent implements OnInit {

  readonly parseFloat = Number.parseFloat;

  feljegyzesek = []
  user$
  loginMode
  userMetadata
  uuid
  @ViewChild('feljegyzesmodal') feljegyzesmodal: IonModal;
  @ViewChild('tetelesAdoModal') tetelesAdoModal: IonModal;
  f
  sajatIntezmeny
  ugyfel
  tortenet
  adofszla
  folyoszamla
  kapocs = false
  kapocsTol = ''
  kapocsIg = ''


  constructor(private route: ActivatedRoute, private alertController: AlertController, public oauth: OAuthService, private data: DataService, private http: HttpClient) { }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims()) as any;
    this.loginMode = await this.data.getFromStorage("loginmode")
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.initializeKapocsDateRange()

    let param = await this.route.snapshot.paramMap.get('adoszam');
    console.log(param)
    if (window.location.pathname.includes("kapocs"))
      this.http
        .get(
          '/api/ugyfel?ugyfel=' + encodeURIComponent(param)
        )
        .subscribe({
          next: async (response: any) => {
            this.ugyfel = response[0];
            await this.data.setStorage("kivceg", this.ugyfel)
            console.log(this.ugyfel)
            this.kapocs = true
            this.masodik()
            await this.data.hideLoading()
          },
        });
    else {
      this.ugyfel = (await this.data.getFromStorage("kivceg"))
      this.masodik()
    }


    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    //this.userMetadata.department = "rendszergazda"


  }

  private formatDateOnly(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }

  private normalizeDateOnly(value: any) {
    const parsed = moment(value);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
  }

  private initializeKapocsDateRange() {
    const previousMonthStart = moment().subtract(1, 'month').startOf('month').toDate();
    const previousMonthEnd = moment().subtract(1, 'month').endOf('month').toDate();

    this.kapocsTol = this.formatDateOnly(previousMonthStart);
    this.kapocsIg = this.formatDateOnly(previousMonthEnd);
  }

  onKapocsDateChange(field: 'tol' | 'ig', event: any) {
    const value = this.normalizeDateOnly(event?.detail?.value ?? event?.target?.value ?? event);
    if (!value) return;

    if (field == 'tol') {
      this.kapocsTol = value;
      return;
    }

    this.kapocsIg = value;
  }

  private syncKapocsDateInputs() {
    const tolInput = document.getElementById('kapocsTolInput') as any;
    const igInput = document.getElementById('kapocsIgInput') as any;

    const tol = this.normalizeDateOnly(tolInput?.value ?? this.kapocsTol);
    const ig = this.normalizeDateOnly(igInput?.value ?? this.kapocsIg);

    if (tol) this.kapocsTol = tol;
    if (ig) this.kapocsIg = ig;
  }

  async masodik() {
    this.uuid = this.user$.username
    if (this.loginMode == "dolgozo") {
      await this.data.showLoading("Bankszámlák betöltése...")
      this.http
        .get(
          '/api/ugyfelbank?azonosito=' + encodeURIComponent(this.ugyfel.AZONOSITO)
        )
        .subscribe({
          next: async (response: any) => {
            console.log(response)
            this.feljegyzesek = response;
            await this.data.hideLoading()
            if (this.ugyfel.NAVM2M && !window.location.pathname.includes("kapocs")) {
              await this.data.showLoading("NAV adatok betöltése...")
              this.http
                .post(
                  'https://api.cronom.it/webhook/getNavCsokor',
                  { m2m: this.ugyfel.NAVM2M, token2: this.ugyfel.NAVTOKEN2, adoszam: this.ugyfel.ADOSZAM.split("-")[0] }
                )
                .subscribe({
                  next: async (response2: any) => {
                    console.log(response2)

                    this.adofszla = response2[0];
                    this.folyoszamla = null;
                    await this.data.hideLoading()
                  },
                  error: async () => {
                    await this.data.hideLoading()
                  },
                });
            }
          },
          error: async () => {
            await this.data.hideLoading()
          },
        });


    }
  }

  async openTetelesAdoszamla() {
    if (!this.ugyfel?.NAVM2M) {
      this.data.sendToast("NAV M2M azonosító nincs beállítva.", "error")
      return;
    }

    await this.data.showLoading("Részletes adószámla betöltése...")
    this.http
      .post(
        'https://api.cronom.it/webhook/getTetelesAdoszamla',
        {
          m2m: this.ugyfel.NAVM2M,
          token2: this.ugyfel.NAVTOKEN2,
          adoszam: this.ugyfel.ADOSZAM.split("-")[0]
        }
      )
      .pipe(
        timeout(120000),
        catchError((error) => {
          console.error(error)
          this.data.sendToast("A tételes adószámla lekérése nem sikerült.", "error")
          return of(null)
        }),
        finalize(async () => {
          await this.data.hideLoading()
        })
      )
      .subscribe((response: any) => {
        if (!response) {
          return;
        }

        this.folyoszamla = Array.isArray(response) ? response[0] : response;
        if (!this.folyoszamla?.tetelesAdoszamla) {
          this.data.sendToast("Nem érkezett tételes adószámla adat.", "error")
          return;
        }

        this.tetelesAdoModal?.present();
      });
  }

  closeTetelesAdoModal() {
    this.tetelesAdoModal?.dismiss()
  }

  exportTetelesAdoPdf() {
    const printable = document.getElementById('teteles-ado-print-content');
    if (!printable) {
      this.data.sendToast('Nincs nyomtathato adoszamla tartalom.', 'error')
      return;
    }

    const win = window.open('', '_blank');
    if (!win) {
      this.data.sendToast('A bongeszo blokkolta az uj ablakot.', 'error')
      return;
    }

    const cegnev = this.ugyfel?.NEV || this.ugyfel?.CEGNEV || this.ugyfel?.name || '';
    const adoszam = this.ugyfel?.ADOSZAM || '';
    const dateStr = moment().format('YYYY-MM-DD HH:mm');

    win.document.open();
    win.document.write(`
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Teteles adoszamla</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 16px; color: #111; }
            h1 { margin: 0 0 8px 0; font-size: 20px; }
            .meta { margin-bottom: 16px; font-size: 12px; color: #444; }
            table { border-collapse: collapse; width: 100%; margin-bottom: 16px; }
            th, td { border: 1px solid #ddd; padding: 4px; font-size: 11px; }
            th { background: #f1f5f9; text-transform: uppercase; }
            .row-color-red { background: #fee2e2; }
            .row-color-green { background: #dcfce7; }
            @media print {
              body { margin: 8px; }
            }
          </style>
        </head>
        <body>
          <h1>Teteles adoszamla</h1>
          <div class="meta">Cegnev: ${cegnev} | Adoszam: ${adoszam} | Generalva: ${dateStr}</div>
          ${printable.innerHTML}
        </body>
      </html>
    `);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 200);
  }

  close() {
    this.feljegyzesmodal.dismiss()
  }
  isAktiv(sz) {
    return moment(sz) >= moment()
  }
  async openFeljegyzes(f) {
    this.tortenet = []
    if(this.kapocs){
      this.syncKapocsDateInputs()
      await this.data.showLoading("Egy pillanat...")
      const from = this.kapocsTol ? `&tol=${encodeURIComponent(this.kapocsTol)}` : '';
      const to = this.kapocsIg ? `&ig=${encodeURIComponent(this.kapocsIg)}` : '';
      if(this.isAktiv(f.BSZINKRONDATUM) && f.id.split('|')[2] != 'STRIPE')
      this.http
        .get(
          environment.n8n +
          '/webhook/hulk/2?szinkron=1&companyId=' + this.ugyfel.ADOSZAM + "&iban="+f.id+"&azon="+this.ugyfel.AZONOSITO+"&intezmeny="+this.sajatIntezmeny.intezmenyId+"&email="+this.ugyfel.EMAIL + from + to
        )
        .subscribe({
          next: async (response: any) => {
            await this.data.hideLoading()
              //alert("Sikeres párosítás, itt lesz a kontír menü")
              window.location.replace("/b/kontir/"+this.ugyfel.ADOSZAM)
          },
          error: async () => {
            await this.data.hideLoading()
          }})
          else if(f.id.split('|')[2] == 'STRIPE') 
            window.location.replace(environment.n8n + "/webhook/getkivonat?dok=bank&szlaszam=" + f.id + "&lekero=" + this.user$.username + from + to);
          else
            window.location.replace(environment.n8n+'/form/20b722f1-ce23-4fd5-a19a-28eb9b933a9f?companyId=' + this.ugyfel.ADOSZAM)
      
    }else if (f.id.split('|')[2] == 'STRIPE') {
      if (f.banktipus) {
        window.open(environment.n8n + "/webhook/getkivonat?dok=bank&szlaszam=" + f.id + "&lekero=" + this.user$.username, '_blank').focus();
      } else {
        alert("Nincs API-kulcs megadva!")
      }

    } else if (this.isAktiv(f.BSZINKRONDATUM)) {
      alert("Bankszinkron aktív!")
      return
      await this.data.showLoading("Bankszámlatörténet betöltése...")
      this.http
        .post(
          "https://api.cronom.it" +
          '/webhook/2ca0f136-40fa-42db-a03b-2abe9f4d1c83',
          { email: this.ugyfel.EMAIL, ugyfel: this.ugyfel.AZONOSITO, intezmeny: this.sajatIntezmeny.intezmenyId, userflow: "PULL_HISTORY", iban: f.id }
        )
        .subscribe({
          next: async (response: any) => {

            this.tortenet = response[0].transactions;
            console.log(this.tortenet)
            await this.data.hideLoading()
          },
        });
      this.f = f
    } else {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Bankszinron inaktív!',
        message: 'Elindítja a banki összekötést?',
        buttons: [
          {
            text: 'Mégse',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Igen',
            handler: async () => {
              console.log('Confirm Okay');
              await this.data.showLoading("Kapcsolat kiépítése...")
              let more = ""
              if (f.banktipus) {
                more = "&iban=" + f.id + "&bid=" + f.banktipus
              }
              this.http
                .post(
                  "https://api.cronom.it" +
                  '/webhook/2ca0f136-40fa-42db-a03b-2abe9f4d1c83',
                  { email: this.ugyfel.EMAIL, ugyfel: this.ugyfel.AZONOSITO, intezmeny: this.sajatIntezmeny.intezmenyId, userflow: "ADD_BANK", iban: f.id }
                )
                .subscribe({
                  next: async (response: any) => {
                    await this.data.hideLoading()

                    await Browser.open({ url: response.url });
                    const alert2 = await this.alertController.create({
                      cssClass: 'my-custom-class',
                      header: 'Bankszinron folyamat elindítva!',
                      message: 'A folyamat végén kattintson a frissítés gombra!',
                      buttons: [
                        {
                          text: 'Frissítés',
                          role: 'cancel',
                          cssClass: 'secondary',
                          handler: (blah) => {
                            window.location.reload()
                          }
                        }]
                    });
                    await alert2.present()
                  },
                  error: async () => {
                    await this.data.hideLoading()
                  },
                });
            }
          }, {
            text: 'Email ügyfélnek',
            handler: async () => {
              console.log('Confirm Okay');
              await this.data.showLoading("Email küldése...")
              let more = ""
              if (this.ugyfel.BANKID) {
                more = "&iban=" + f.id + "&bid=" + f.banktipus
              }
              this.http
                .post(
                  "https://api.cronom.it" +
                  '/webhook/2ca0f136-40fa-42db-a03b-2abe9f4d1c83',
                  { email: this.ugyfel.EMAIL, ugyfel: this.ugyfel.AZONOSITO, intezmeny: this.sajatIntezmeny.intezmenyId, userflow: "ADD_BANK", eredmeny: "email", iban: f.id }
                )
                .subscribe({
                  next: async (response: any) => {
                    await this.data.hideLoading()
                    this.data.sendToast("Sikeres küldés!", "success")

                  },
                  error: async () => {
                    await this.data.hideLoading()
                  },
                });
            }
          }
        ]
      });

      await alert.present();
    }
    /*console.log(f)
    this.f = f
    this.feljegyzesmodal.present()*/
  }


}
